module.exports = __webpack_public_path__ + "img/BSE_logo_horizontal_dark.826c6dc9.png";